import React from 'react';
import { ErrorMessage, Form, Formik, FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { LargeButton } from 'pg-ui-library';
import { ISecurityQuestion } from '../../../interfaces';
import {
  CenterText,
  CloseIcon,
  EmailIcon,
  FormTitle,
  ResetPasswordWrapper,
  InputLabel,
  Input,
  ModalInput,
  StyledErrorWrap,
} from '../styles';
import emailSvg from '../../../assets/email.svg';
import closeSvg from '../../../assets/close.svg';
import getSecurityQuestionsService from '../../../services/get-security-questions.service';

interface IQuestionsRetriever {
  email: string;
}

export const ResetPasswordEmailForm: React.FC<{
  handleModal: Function;
  handleModalState: Function;
  setSecurityQuestionAnswer: Function;
  setEmail: Function;
}> = ({ handleModal, handleModalState, setSecurityQuestionAnswer, setEmail }) => {
  const { t } = useTranslation();

  const emailSchema = yup.object({
    email: yup.string().required(t('global.form.required')).email(t('global.form.email')),
  });

  const onSubmit = async (values: IQuestionsRetriever, { setFieldError }: FormikHelpers<IQuestionsRetriever>) => {
    try {
      const data = await getSecurityQuestionsService.getQuestionsByEmail(values.email);

      const questions = data.map((question: ISecurityQuestion) => ({
        questionId: question.id,
        answer: '',
        question: question.question,
      }));

      setSecurityQuestionAnswer(questions);
      setEmail(values.email);
      handleModalState(1);
    } catch (error: any) {
      setFieldError('email', error.message);
    }
  };

  return (
    <Formik
      initialValues={{
        email: '',
      }}
      validationSchema={emailSchema}
      onSubmit={onSubmit}
    >
      {({ handleChange, isSubmitting }) => (
        <Form
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <CloseIcon src={closeSvg} onClick={() => handleModal()} />
          <FormTitle>{t('login.resetPassword.title')}</FormTitle>
          <CenterText>{t('login.resetPassword.text')}</CenterText>
          <ResetPasswordWrapper>
            <InputLabel>{t('login.form.email')}</InputLabel>
            <ModalInput>
              <EmailIcon src={emailSvg} />
              <Input
                data-cy="reset-password-email-input"
                type="email"
                id="email"
                name="email"
                placeholder={t('login.resetPassword.email')}
                onChange={handleChange}
              />
            </ModalInput>
            <ErrorMessage data-cy="reset-password-email-error" name="email" component={StyledErrorWrap} />
            <LargeButton data-cy="reset-password-submit-button" type="submit" disabled={isSubmitting}>
              {t('login.resetPassword.button')}
            </LargeButton>
          </ResetPasswordWrapper>
        </Form>
      )}
    </Formik>
  );
};
